import { isPhoneNumber } from 'class-validator';

function validateNumber(number: string): boolean {
  return number.length > 8 && isPhoneNumber(number);
}

export default validateNumber;
